var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1088,
    height: 1708,
    viewBox: "0 0 1088 1708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1487_1337)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.5,
    cy: 373.5,
    r: 373.5,
    transform: "matrix(-1 0 0 1 1440.5 527)",
    fill: "#830BE1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.5 1.9996C1325.05 1.99958 1706.5 383.453 1706.5 854C1706.5 1324.55 1325.05 1706 854.5 1706C383.953 1706 2.49998 1324.55 2.49996 854C2.49994 383.453 383.953 1.99962 854.5 1.9996ZM854.5 -0.00040354C1326.15 -0.000424157 1708.5 382.348 1708.5 854C1708.5 1325.65 1326.15 1708 854.5 1708C382.849 1708 0.499983 1325.65 0.499963 854C0.499942 382.349 382.849 -0.000382924 854.5 -0.00040354ZM854.499 204.986C1212.94 204.986 1503.51 495.56 1503.51 854.001C1503.51 1212.44 1212.94 1503.02 854.499 1503.02C496.058 1503.02 205.484 1212.44 205.484 854.001C205.484 495.56 496.058 204.986 854.499 204.986ZM854.499 202.986C1214.04 202.986 1505.51 494.455 1505.51 854.001C1505.51 1213.55 1214.05 1505.02 854.499 1505.02C494.954 1505.02 203.484 1213.55 203.484 854.001C203.484 494.455 494.954 202.986 854.499 202.986ZM1337.1 854C1337.1 587.465 1121.03 371.396 854.5 371.396C587.966 371.396 371.896 587.465 371.896 854C371.896 1120.53 587.966 1336.6 854.5 1336.6C1121.03 1336.6 1337.1 1120.53 1337.1 854ZM1339.1 854C1339.1 586.36 1122.14 369.396 854.5 369.396C586.861 369.396 369.896 586.36 369.896 854C369.896 1121.64 586.861 1338.6 854.5 1338.6C1122.14 1338.6 1339.1 1121.64 1339.1 854ZM854.5 523.178C1037.21 523.178 1185.32 671.292 1185.32 854C1185.32 1036.71 1037.21 1184.82 854.5 1184.82C671.792 1184.82 523.678 1036.71 523.678 854C523.678 671.292 671.792 523.178 854.5 523.178ZM854.5 521.178C1038.31 521.178 1187.32 670.187 1187.32 854C1187.32 1037.81 1038.31 1186.82 854.5 1186.82C670.687 1186.82 521.678 1037.81 521.678 854C521.678 670.187 670.687 521.178 854.5 521.178Z",
    fill: "url(#paint0_radial_1487_1337)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1487_1337",
    x: 293.5,
    y: 127,
    width: 1547,
    height: 1547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_1487_1337"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1487_1337",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(576 854) scale(642.283 1227.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.6cf2603b9a2e91b20fbd9a1f4f856d4d.svg";
export { ForwardRef as ReactComponent };